module.exports = __webpack_public_path__ + "static/media/bird_fly04.cff3cf50.gif";